import { render } from "./WizardContextRing.vue?vue&type=template&id=ef8c2ef6&scoped=true&ts=true"
import script from "./WizardContextRing.vue?vue&type=script&lang=ts"
export * from "./WizardContextRing.vue?vue&type=script&lang=ts"

import "./WizardContextRing.vue?vue&type=style&index=0&id=ef8c2ef6&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef8c2ef6"]])

export default __exports__